<template>
    <div class="goodsmaterial spackage padding-20 bgc box-shadow" v-loading="loading">

        <!-- 顶部菜单栏 -- start -->
        <section class="gcm-header">
            <div align="right" class="gcm_header_box">
                <p>订购状态</p>
                <el-select v-model="currentStatus" placeholder="全部状态">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <p>订购时间</p>
                <el-date-picker v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy/MM/dd" :picker-options="pickerOptions"></el-date-picker>
                <el-button type="primary" @click="search()" plain>搜索</el-button>
            </div>
        </section>
        <!-- 顶部菜单栏 -- end -->

        <!-- 表单 -- start -->
        <section>
            <el-table :data="tableData">
                <el-table-column prop="datetime" label="创建时间" align="center" width="200"></el-table-column>
                <el-table-column prop="moduletype" label="服务内容" align="center" width="200"></el-table-column>
                <el-table-column prop="servicetype" label="服务类型" align="center"></el-table-column>
                <el-table-column prop="finalpaymoney" label="费用（元）" align="center"></el-table-column>
                <el-table-column prop="invoicestatusname" label="发票" align="center"></el-table-column>
                <el-table-column label="订单状态" align="center">
                    <template slot-scope="scope">
                        <div class="table-status">
                            <p class="status-1" v-if="scope.row.status == 30">订购成功</p>
                            <p class="status-4" v-if="scope.row.status == 9">待支付</p>
                            <p class="status-5" v-if="scope.row.status == 100">订单已取消</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right" width="180">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button v-if="scope.row.status === 9" @click="toPay(scope.row.orderno)" class="to_pay">去支付</el-button>
                            <el-button @click="checkOrder(scope.row.orderno)">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- 表单 -- end -->

        <!-- 分页 -- start -->
        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- 分页 -- end -->

    </div>
</template>

<script>
import {getShopmoduleorderinfoList, getOrderPayUrl} from '@/api/orderService'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
import $ from 'jquery'

export default {
    name: 'orderRecordList',
    data() {
        return {
            loading: false,
            token: getCookie('token'),
            sessionUser: JSON.parse(sessionStorage['user']),
            shopID: JSON.parse(sessionStorage['shop']).ShopID,
            currentPage: 1,
            rowCount: 0,
            page: 1,
            tableData: [],
            statusList: [
                {
                    value: 30,
                    label: '订购成功'
                },
                {
                    value: 9,
                    label: '待支付'
                },
                {
                    value: 100,
                    label: '订单已取消'
                }
            ],
            currentStatus: '',
            isStop: false,
            currentid: '',
            timeRange: '',
            beginTime: '',
            endTime: '',
            pickerOptions: {
                onPick(maxDate, minDate) {
                    console.log(maxDate, minDate)
                }
            }
        }
    },
    mounted() {
        this.setLoading(true)
        this.getOrderList(1)
    },
    methods: {
        // 获取订购列表
        getOrderList(page) {
            let data = {
                status: this.currentStatus,
                page: page,
                pageSize: 10,
                beginTime: this.beginTime,
                endTime: this.endTime
            }
            // console.log(data)
            getShopmoduleorderinfoList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 查看订单
        checkOrder(id) {
            this.$router.push({name: 'orderDetail', query: {'orderno': id}})
        },

        // 去支付
        toPay(id) {
            let data = {
                orderno: id
            }
            this.setLoading(true)
            getOrderPayUrl({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                       let url = data.data
                       console.log(url)
                       window.location = url
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        
        // 搜索
        search() {
            this.setLoading(true)
            this.getOrderList(1)
        },

        // 分页
        fPage() {
            this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getOrderList(clickPage)
        },

        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'timeRange': {
            handler(newValue, oldValue) {
                if (!newValue) {
                    this.beginTime = ''
                    this.endTime = ''
                } else {
                    this.beginTime = newValue[0]
                    this.endTime = newValue[1]
                }
            }
        },
        deep: true
    },
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .goodsmaterial {
        .share_box {
            .el-dialog {
                width: 305px;
                height: 320px;
                .el-dialog__header {
                    padding: unset;
                }
                .box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    height: 270px;
                    img {
                        width: 150px;
                        height: 150px;
                    }
                    .copy_box {
                        display: flex;
                        justify-content: space-between;
                        .el-input__inner {
                            border-radius: 4px 0 0 4px;
                        }
                        .el-button {
                            margin-bottom: unset;
                            border-radius: 0 4px 4px 0;
                        }
                    }
                }
            }
        }
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
        .gcm-header {
            height: 40px;
            margin-bottom: 40px;
            .gcm_header_box {
                display: flex;
                align-items: center;
                p {
                    margin-right: 10px;
                }
                .el-button {
                    margin-left: 30px;
                }
            }
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }
        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
            .to_pay {
                width: 58px;
                height: 28px;
                background: rgba(64,158,255,1);
                border-radius: 2px;
                font-size: 14px;
                line-height: 28px;
                text-align: center;
                span {
                    color: #fff;
                }
            }
        }
        .dele_dialog {
            border-radius: 4px;
            text-align: center;
            .dele_tips {
                color: #F56C6C;
            }
        }
        .table-status {
            .status-4 {
                color: #F56C6C;
            }
            .status-5 {
                color: #C0C4CC;
            }
        }
    }
</style>
